var _rect, _g, _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibleCorner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 48,
    viewBox: "0 0 65 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 62,
    height: 46,
    rx: 7,
    fill: "#EEF2F5",
    stroke: "#16B364",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_725_10414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.58984,
    y: 9,
    width: 51.8182,
    height: 30,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1191 19.2373C10.1191 18.1327 11.0146 17.2373 12.1191 17.2373H23.1191C24.2237 17.2373 25.1191 18.1327 25.1191 19.2373V34.2961H10.1191V19.2373Z",
    fill: "#19184A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1191 34.2948C10.1191 30.7212 13.0161 27.8242 16.5897 27.8242H18.6486C22.2222 27.8242 25.1191 30.7212 25.1191 34.2948H10.1191Z",
    fill: "#558BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.876,
    y: 13.2852,
    width: 36.4286,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4473,
    y: 13.2852,
    width: 4.28571,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0186,
    y: 19.7148,
    width: 25.7143,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0186,
    y: 26.1436,
    width: 25.7143,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0186,
    y: 32.5703,
    width: 25.7143,
    height: 2.14286,
    fill: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.6111,
    cy: 22.8474,
    r: 3.67359,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 10.5,
    r: 6.5,
    fill: "#16B364"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0684 10.1633L53.1646 12.4125L57.4409 7.82422",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_725_10414",
    x: 4.58984,
    y: 7,
    width: 55.8184,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_725_10414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_725_10414",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleCorner);
export default __webpack_public_path__ + "static/media/visibleCorner.d040425ae9ac16bf46a99e5adb2e3c22.svg";
export { ForwardRef as ReactComponent };